import { render, staticRenderFns } from "./RawInfo.vue?vue&type=template&id=bb80c57a&scoped=true&"
import script from "./RawInfo.vue?vue&type=script&lang=js&"
export * from "./RawInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb80c57a",
  null
  
)

export default component.exports